/**
 * Shared type treatment for the auth screens that sit on AuthLayout's frosted
 * panel (Login, AcceptInvite, ActivateAccount).
 *
 * These screens used to render their content inside a white card on top of the
 * panel, which meant dark-on-white type. Content now sits directly on the
 * panel, so everything has to be white — and has to stay white in step across
 * the screens, hence one definition rather than three copies.
 *
 * Mirrors the heading Login declares inline; AuthLayout supplies the branding,
 * so a screen should not draw its own logo.
 */
export const AUTH_HEADING_CLASS =
  "tablet-landscape:text-22p text-28p text-white font-bold tablet-landscape:text-left text-center";

export const AUTH_BODY_CLASS = "text-white text-md font-semibold mt-4";

/** Content width Login passes to AuthLayout's `contentClass`. */
export const AUTH_CONTENT_CLASS = "w-85";
